import { memo } from 'react';
import { useResizeDetector } from 'hooks';

export default memo(function PdfEmbed({ url, children, ...other }) {
  const { width, ref } = useResizeDetector({ refreshMode: undefined, handleHeight: false });
  let height = width * 1.5;
  if (!width || height > 1200) { height = 1200; }

  if (!url) { return null; }

  return <div ref={ref}>
    <object data={url} type="application/pdf" width={width} height={height} { ...other }>
      <param value={url} name="src" />
      <param value="transparent" name="wmode" />
      {children}
    </object>
  </div>;
});